import { axiosConfig } from '../api/axios-config.js'

// 第三方拋轉紀錄查詢
export const thirdPartyLog = {
  // 取得紀錄清單
  get: (params, token) => axiosConfig.get('/api/third-party-logs', { ...token, params }),

  // 取得單一紀錄詳情
  getDetail: (id, token) => axiosConfig.get(`/api/third-party-logs/${id}`, token),

  // 取得平台選項
  getPlatforms: (token) => axiosConfig.get('/api/third-party-logs/platforms', token),

  // 取得資料類型選項
  getDataTypes: (token) => axiosConfig.get('/api/third-party-logs/data-types', token),

  // 取得狀態選項
  getStatuses: (token) => axiosConfig.get('/api/third-party-logs/statuses', token),
}
